function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRenault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 25,
    style: {
      fill: "silver",
      font: "9px sans-serif"
    }
  }, "\n    RENAULT\n  "));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenault);
export default __webpack_public_path__ + "static/media/renault.6baba3351f0745abe4a5d8dd3af61996.svg";
export { ForwardRef as ReactComponent };